import { getVenuesAction, getVenuesCountriesAction, getVenuesProductionsAction } from './actions';
import { namedListParams, listReducer } from '../../utils/crudUtils';

export const key = 'Venues';

export const initialState = {
  venues: namedListParams('venues'),
  venueProductions: namedListParams('venueProductions'),
  countries: namedListParams('countries'),
};

const productionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getVenuesAction.TRIGGER:
    case getVenuesAction.SUCCESS:
    case getVenuesAction.FAILURE:
      return listReducer(state, type, payload, initialState.venues.listName);

    case getVenuesCountriesAction.TRIGGER:
    case getVenuesCountriesAction.SUCCESS:
    case getVenuesCountriesAction.FAILURE:
      return listReducer(state, type, payload, initialState.countries.listName);

    case getVenuesProductionsAction.TRIGGER:
    case getVenuesProductionsAction.SUCCESS:
    case getVenuesProductionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.venueProductions.listName);

    default:
      return state;
  }
};

export default productionsReducer;
